export type FaqItem = { question: string; answer?: string; items?: string[]; outro?: string };

export const faqItems: FaqItem[] = [
  {
    question: "Pouvez-vous m'aider à trouver un van ou un fourgon aménagé ?",
    answer:
      "Oui. Many Loisirs vous accompagne dans la recherche de votre van ou fourgon, qu'il soit neuf ou d'occasion. Nous nous appuyons sur un réseau de concessionnaires partenaires en France et en Allemagne afin de sélectionner un véhicule fiable, adapté à votre projet d'aménagement et à votre budget.",
  },
  {
    question: "Recherchez-vous des véhicules en France et à l'étranger ?",
    answer: "Oui. Nous recherchons des véhicules :",
    items: ["en France", "en Allemagne, reconnue pour la qualité et la diversité de son marché de véhicules utilitaires"],
    outro: "Cette approche élargie nous permet de vous proposer davantage de modèles et de configurations.",
  },
  {
    question: "Proposez-vous des vans aménagés clé en main ?",
    answer: "Oui. Nous proposons :",
    items: [
      "des véhicules de loisirs déjà aménagés",
      "des utilitaires prêts à être transformés en van ou fourgon aménagé",
      "des projets clé en main ou sur mesure",
    ],
    outro: "Vous choisissez le niveau d'accompagnement qui correspond à votre besoin.",
  },
  {
    question: "Puis-je confier à Many Loisirs la recherche du véhicule et son aménagement ?",
    answer: "Oui. Nous prenons en charge l'ensemble du projet :",
    items: [
      "recherche du véhicule",
      "sélection du modèle adapté",
      "aménagement en véhicule de loisirs VASP",
      "accompagnement administratif lié à l'homologation",
    ],
    outro: "Cela vous garantit un projet cohérent, sécurisé et sans mauvaise surprise.",
  },
  {
    question: "Quels types de véhicules proposez-vous ?",
    answer: "Nous proposons :",
    items: [
      "des véhicules neufs",
      "des véhicules d'occasion en stock",
      "des utilitaires à aménager",
      "des vans et fourgons compatibles VASP",
    ],
    outro: "Chaque véhicule est sélectionné selon des critères de fiabilité, de qualité et d'usage.",
  },
  {
    question: "Est-il possible de faire reprendre mon ancien véhicule ?",
    answer:
      "Oui. Nous proposons, sous conditions, une solution de reprise de votre ancien véhicule. Cela permet de faciliter votre transition vers un nouveau van ou fourgon aménagé et d'optimiser votre budget global.",
  },
  {
    question: "Pourquoi passer par Many Loisirs pour un projet de van aménagé ?",
    answer: "Faire appel à Many Loisirs, c'est bénéficier :",
    items: [
      "d'un interlocuteur unique",
      "d'une expertise spécialisée en véhicules de loisirs",
      "d'un accompagnement de la recherche à l'aménagement",
      "d'un projet pensé selon votre mode de vie et votre usage réel",
    ],
    outro: "Nous privilégions la simplicité, la transparence et la qualité.",
  },
  {
    question: "À qui s'adressent vos solutions de vans et fourgons aménagés ?",
    answer: "Nos solutions s'adressent à :",
    items: [
      "des couples",
      "des familles avec enfants",
      "des voyageurs solo",
      "des nomades digitaux",
      "des retraités en quête de liberté",
    ],
    outro: "Chaque projet est personnalisé selon votre façon de voyager et de vivre.",
  },
  {
    question: "Comment démarrer un projet de van ou fourgon aménagé ?",
    answer:
      "Il suffit de nous contacter. Nous échangeons sur votre besoin, votre budget et votre usage, puis nous vous proposons une solution adaptée.",
  },
];
